import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const SocialGallery = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const galleryImages = [
    {
      url: 'https://public.readdy.ai/ai/img_res/58cd0fa050efea6c06891a1a758b6c83.jpg',
      platform: 'instagram',
      likes: 234,
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Beautiful%20finished%20patio%20with%20decorative%20concrete%20patterns%2C%20outdoor%20living%20space%20with%20furniture%2C%20professional%20patio%20installation%20completed%20project%2C%20simple%20neutral%20background%2C%20warm%20evening%20lighting%2C%20inviting%20atmosphere&width=600&height=800&seq=gallery-02&orientation=portrait',
      platform: 'facebook',
      likes: 189,
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Intricate%20paver%20driveway%20design%20with%20geometric%20patterns%2C%20completed%20paver%20installation%20project%2C%20professional%20craftsmanship%20detail%20shot%2C%20simple%20neutral%20background%2C%20bright%20natural%20lighting%2C%20sharp%20focus%20on%20pattern%20details&width=600&height=600&seq=gallery-03&orientation=squarish',
      platform: 'instagram',
      likes: 312,
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Finished%20concrete%20foundation%20work%20for%20new%20construction%2C%20professional%20commercial%20concrete%20project%2C%20construction%20site%20with%20completed%20foundation%2C%20simple%20neutral%20background%2C%20clear%20daylight%2C%20industrial%20quality%20work&width=600&height=800&seq=gallery-04&orientation=portrait',
      platform: 'instagram',
      likes: 156,
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Completed%20decorative%20concrete%20patio%20with%20stamped%20pattern%2C%20beautiful%20outdoor%20entertainment%20area%2C%20finished%20residential%20project%20with%20furniture%2C%20simple%20neutral%20background%2C%20golden%20hour%20lighting%2C%20welcoming%20outdoor%20space&width=600&height=600&seq=gallery-05&orientation=squarish',
      platform: 'facebook',
      likes: 278,
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Professional%20paver%20walkway%20installation%20completed%2C%20curved%20pathway%20through%20landscaped%20garden%2C%20finished%20residential%20project%20with%20plants%2C%20simple%20neutral%20background%2C%20natural%20daylight%2C%20beautiful%20curb%20appeal&width=600&height=600&seq=gallery-06&orientation=squarish',
      platform: 'instagram',
      likes: 201,
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Completed%20concrete%20steps%20and%20entrance%20way%2C%20professional%20residential%20concrete%20stairs%2C%20finished%20project%20with%20clean%20lines%2C%20simple%20neutral%20background%2C%20bright%20natural%20lighting%2C%20welcoming%20home%20entrance&width=600&height=800&seq=gallery-07&orientation=portrait',
      platform: 'facebook',
      likes: 167,
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Finished%20commercial%20concrete%20flooring%20project%2C%20polished%20concrete%20floor%20in%20modern%20space%2C%20professional%20industrial%20concrete%20work%20completed%2C%20simple%20neutral%20background%2C%20even%20lighting%2C%20sleek%20contemporary%20finish&width=600&height=600&seq=gallery-08&orientation=squarish',
      platform: 'instagram',
      likes: 245,
    },
  ];

  return (
    <section id="gallery" className="bg-[#1A1A1A] py-24 lg:py-32" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 lg:px-16">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-5xl lg:text-6xl font-black text-white mb-8">FOLLOW OUR WORK</h2>
          
          {/* Social Icons */}
          <div className="flex items-center justify-center gap-8 mb-4">
            <a
              href="https://www.facebook.com/aandbconcretellc"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 text-brand-green hover:text-brand-green/80 transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center">
                <i className="ri-facebook-fill text-4xl"></i>
              </div>
            </a>
            <a
              href="https://www.instagram.com/aandbconcretellc"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 text-brand-green hover:text-brand-green/80 transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center">
                <i className="ri-instagram-line text-4xl"></i>
              </div>
            </a>
          </div>
          <p className="text-white text-base">@aandbconcretellc</p>
        </motion.div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
          {galleryImages.map((image, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={inView ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              className="group relative rounded-xl overflow-hidden cursor-pointer aspect-square"
            >
              <img
                src={image.url}
                alt={`Gallery ${index + 1}`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
              
              {/* Hover Overlay */}
              <div className="absolute inset-0 bg-black/70 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <div className="text-center text-white">
                  <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                    <i className={`${image.platform === 'instagram' ? 'ri-instagram-line' : 'ri-facebook-fill'} text-4xl text-brand-green`}></i>
                  </div>
                  <div className="flex items-center gap-2 justify-center">
                    <i className="ri-heart-fill text-red-500"></i>
                    <span className="font-semibold">{image.likes}</span>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Load More Button */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center"
        >
          <a
            href="https://www.instagram.com/aandbconcretellc"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block border-2 border-white text-white px-12 py-4 rounded-full font-semibold hover:bg-white hover:text-black transition-all whitespace-nowrap cursor-pointer"
          >
            VIEW MORE ON INSTAGRAM
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default SocialGallery;